<template>
  <van-swipe
    :key="swipeKey"
    :class="$style.swipeSection"
    :autoplay="3000"
    indicator-color="white"
    height="158px"
  >
    <van-swipe-item
      v-for="(item, index) in validList"
      :key="`${item.id || index}-${swipeKey}`"
      @click="$dmbcResourceClick(item)"
    >
      <van-image
        :src="item.icon"
        :alt="item.title || '轮播图片'"
        lazy-load
        :class="$style.swipeImage"
        fit="cover"
        error-icon="photo-fail"
        loading-icon="photo"
      />
    </van-swipe-item>
  </van-swipe>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    name: 'SwipeSection',

    props: {
      list: {
        type: Array,
        default: () => [],
      },
    },

    data() {
      return {
        swipeKey: 0, // 用于强制重新渲染轮播组件
      }
    },

    computed: {
      // 过滤有效的轮播数据
      validList() {
        return this.list
      },
    },

    watch: {
      // 监听list变化，确保轮播组件正确更新
      list: {
        handler() {
          this.$nextTick(() => {
            // 强制重新渲染轮播组件
            this.swipeKey += 1
          })
        },
        deep: true,
        immediate: false,
      },
    },
  })
</script>

<style lang="scss" module>
  .swipeSection {
    width: 100%;
    height: 158px;
    overflow: hidden;
  }

  .swipeImage {
    width: 100%;
    height: 100%;
  }

  :global {
    .van-swipe__indicators {
      bottom: 6px;
    }

    .van-swipe__indicator {
      width: 4px;
      height: 4px;
      background: #5f7a77;
      border-radius: 9px;
    }

    .van-swipe__indicator:not(:last-child) {
      margin-right: 4px;
    }

    .van-swipe__indicator--active {
      width: 8px;
      background: #ff840a !important;
    }
  }
</style>
